var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53635 10.9722C4.41454 10.1528 3.41061 9.30556 3.41061 7.98611C3.41061 6.47222 4.79961 5.41667 7.12377 5.41667C9.57171 5.41667 10.4794 6.59722 10.5619 8.33333H13.6012C13.5049 5.94444 12.0609 3.75 9.18664 3.04167V2.06287C9.18664 0.923578 8.26306 0 7.12377 0C5.98448 0 5.0609 0.923578 5.0609 2.06287V3C2.39293 3.58333 0.247544 5.33333 0.247544 8.01389C0.247544 11.2222 2.87426 12.8194 6.7112 13.75C10.1493 14.5833 10.8369 15.8056 10.8369 17.0972C10.8369 18.0556 10.1631 19.5833 7.12377 19.5833C4.29077 19.5833 3.17682 18.3056 3.02554 16.6667H0C0.165029 19.7083 2.42043 21.4167 5.0609 21.9861V22.9371C5.0609 24.0764 5.98448 25 7.12377 25C8.26306 25 9.18664 24.0764 9.18664 22.9371V22.0139C11.8684 21.5 14 19.9306 14 17.0833C14 13.1389 10.6582 11.7917 7.53635 10.9722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.0400dbd892238b66568c92eab9cba796.svg";
export { ForwardRef as ReactComponent };